"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiToken = exports.getCsrfToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getCsrfToken = function () {
    return Api_1.api().get('api/communication/getcsrftoken');
};
exports.getApiToken = function () {
    if (process.env.DEV)
        return Promise.resolve('test');
    return exports.getCsrfToken().then(function (res) { return res.data; });
};
